<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="margin-bottom-20">
                <h1 class="h2 margin-bottom-20">Eventi</h1>
            </div>
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";

    export default {
        name: "Events",
        components: { ContainerWithMenu }
    };
</script>
